import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.css']
})
export class SkeletonLoaderComponent {
  @Input() height: string = '18px';
  @Input() width: string = '75px';
  @Input() minWidth: string = '75px';
  @Input() borderRadius: string = '5px';
}
